export default __webpack_public_path__ + "static/media/ExcavationCamp.85f05c8e.jpg";